import { SVGProps, Ref, forwardRef } from 'react';

export const LabelThumbFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m.296 4.127c-.836-.398-1.786.188-1.858 1.071-.082 1.013-.452 1.888-1.097 2.82v8.98h5.318c2.203-.011 3.043-.755 3.352-2.955l.416-2.955c.298-2.121-.278-2.888-2.29-2.95h-2.66V7.365c0-.96-.305-1.82-1.181-2.238M5.5 12.877c0-2.235.704-3.061 2.777-3.145v8.258c-2.073-.084-2.777-.91-2.777-3.144z"
            fill="currentColor"
        />
    </svg>
));
LabelThumbFilledSize24Glyph.displayName = 'LabelThumbFilledSize24Glyph';
